{
    "CmeList_Column_ID": "EU IA",
    "CmeList_Column_Description": "Descrição",
    "CmeList_Column_ChildCMEs": "CMEs",
    "CmeList_Column_TelSyss": "Servidores de telefonia",
    "CmeList_Column_Partitions": "Partições",
    "CmeList_Column_Users": "Usuários",
    "CmeList_CountLink_TelSyssAria": "Servidores de telefonia abertos filtrados para este ambiente CM",
    "CmeList_CountLink_PartitionsAria": "Códigos abertos filtrados para este ambiente CM",
    "CmeList_CountLink_UsersAria": "Usuários de aplicativos abertos filtrados para este ambiente CM",
    "NAME": "CmeListLanguage"
}